<template>
  <div class="edit-wrap">
    <div class="item-card">
      <div class="card-title">广告组名称</div>
      <div class="card-content">
        <ul class="modal-form">
          <el-form :model="tfContent" :rules="rules" ref="tfcontentRef">
            <li class="form-item">
              <span class="form-label require" style="padding-top: 6px"
                >广告组名称：</span
              >
              <div class="form-value">
                <select-input
                  ref="selectInputRef"
                  placeholder="(必填)请输入广告组名称"
                  :dataList="adGroupList"
                  v-model="tfContent.name_rule"
                ></select-input>
              </div>
            </li>
          </el-form>
        </ul>
      </div>
    </div>
    <div class="item-card">
      <div class="card-title">投放范围</div>
      <div class="card-content">
        <ul class="modal-form">
          <el-form :model="adAddress" ref="addressRef">
            <li class="form-item">
              <span class="form-label" style="width: 70px">投放范围：</span>
              <div class="form-value">
                <el-radio-group
                  v-model="adAddress.delivery_range"
                  @change="changRange"
                >
                  <el-radio label="default">默认</el-radio>
                  <el-radio label="unit">快手联盟</el-radio>
                </el-radio-group>
              </div>
            </li>
          </el-form>
        </ul>
      </div>
    </div>
    <!-- 创意基础设置 -->
    <creative-baseset ref="creativeBasesetRef"></creative-baseset>
    <!-- 创意分类 -->
    <creative-classify ref="creativeClassifyRef"></creative-classify>
  </div>
</template>

<script>
// import { mapState } from "vuex";
import CreativeBaseset from "./subBaseset/creativeBaseset.vue";
import CreativeClassify from "./subBaseset/CreativeClassify.vue";
import SelectInput from "./common/selectInput.vue";
import nameTransforUtil from "./common/nameTransforUtil.js";
import { mapState } from "vuex";
export default {
  components: {
    CreativeBaseset,
    CreativeClassify,
    SelectInput,
  },
  data() {
    return {
      adGroupList: [
        "营销目标",
        "应用名称",
        "应用标记",
        "创建日期",
        "优化目标",
        "广告位置",
        "转化跟踪名称",
        "定向包",
        "创意组名称",
        "标题包名称",
        "投放范围",
        "首个视频名称",
      ],
      tfContent: {
        name_rule: "",
      },
      adAddress: {
        delivery_range: "default",
      },
      rules: {},
    };
  },
  methods: {
    //弹框出现时查询表单数据(父组件调用),表单渲染
    initFormData() {
      this.renderData();
      this.$refs.creativeBasesetRef.initOptions();
      this.$refs.creativeClassifyRef.initOptions();
    },
    //弹框关闭保存数据到store(父组件调用)
    saveDataInStore() {
      this.saveInStore();
      this.$refs.creativeBasesetRef.saveInStore();
      this.$refs.creativeClassifyRef.saveInStore();
    },
    //弹框关闭时校验数据格式
    checkData() {
      return Promise.all([
        this.checkCurData(),
        this.$refs.creativeBasesetRef.checkData(),
        this.$refs.creativeClassifyRef.checkData(),
      ]);
    },
    saveInStore() {
      //将表单数据转为接口用数据
      this.$store.commit(
        "set_name_rule_k",
        nameTransforUtil.showDataToApi(this.tfContent.name_rule)
      );
      //保存投放范围
      this.$store.commit("set_delivery_range_k", this.adAddress.delivery_range);
    },
    //实时保存投放范围
    changRange(range) {
      this.$store.commit("set_delivery_range_k", range);
    },
    //数据渲染
    renderData() {
      if (this.name_rule) {
        this.tfContent.name_rule = nameTransforUtil.apiDatatoShow(
          this.name_rule
        );
      }
      this.adAddress.delivery_range = this.delivery_range;
    },
    checkCurData() {
      //广告组名称校验
      return Promise.all([
        this.$refs.selectInputRef.checkData(),
        new Promise((resolve, reject) => {
          this.$refs.tfcontentRef.validate((valid) => {
            if (valid) {
              resolve();
            } else {
              reject();
            }
          });
        }),
      ]);
    },
  },
  computed: {
    ...mapState({
      name_rule: (state) => state.PromotionKuaishou.draft_adset.name_rule,
      delivery_range: (state) =>
        state.PromotionKuaishou.draft_adset.delivery_placement.delivery_range,
    }),
  },
};
</script>

<style lang="less" scoped>
.edit-wrap {
  height: calc(100vh - 63px);
  box-sizing: border-box;
  background: rgba(228, 232, 239, 1);
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  overflow: auto;
  .item-card {
    background-color: #fff;
    padding: 24px;
    margin-bottom: 6px;
    .card-title {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      font-weight: bold;
    }
  }
  .card-content {
    margin-top: 20px;
    .modal-form {
      margin: 0px;
      padding: 0px;
      list-style: none;
      .form-item {
        display: flex;
        margin-bottom: 20px;
        .form-label {
          flex-shrink: 0;
          display: inline-block;
          width: 130px;
          text-align: right;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          // padding-top: 6px;
          &.require::before {
            content: "*";
            display: inline-block;
            color: red;
            margin-right: 4px;
          }
        }
        .form-value {
          width: 100%;
          padding-top: 2px;
          /deep/ .el-radio__input.is-checked .el-radio__inner {
            color: rgba(24, 144, 255, 1);
            border-color: rgba(24, 144, 255, 1);
            background: rgba(24, 144, 255, 1);
          }
          /deep/ .el-radio__input.is-checked + .el-radio__label {
            color: rgba(0, 0, 0, 0.65);
          }
        }
      }
    }
  }
}
</style>